import { React, useState, useEffect, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import "./header.scss";
import "../../../shared/Common/darklayout.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SharedUtils from "../../Common/utils";
import { METADATA_KEY } from '../../../../utils/utils';
import { Box, Stack, Typography } from "@mui/material";
import { Spinner } from "react-bootstrap";

const READONLY_BOX_HIDE_MS = 4000;

const getInitials = (name = "") => {
    const local = String(name).split("@")[0] || "";
    const parts = local.split(/[.\s_-]+/).filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
    }
    return local.slice(0, 2).toUpperCase() || "?";
};

const Header = ({ open = true }) => {
    const dispatch = useDispatch();
    const sidebarState = useSelector((state) => state.header.isOpen);
    const showReadonly = useSelector((state) => state.states.showReadonly);

    const [show_user_menu, setShowMenu] = useState(false);
    const [notwork_down] = useState(false);
    const [userName, setUserName] = useState(() => {
        const localState = JSON.parse(localStorage.getItem('reduxState'));
        return localState?.auth?.username || "";
    });
    const [clientName, setClientName] = useState(
        () => localStorage.getItem("client_name") || ""
    );
    const [isLoading, setIsLoading] = useState(false);
    const [menuPosition, setMenuPosition] = useState(null);
    const triggerRef = useRef(null);
    const menuRef = useRef(null);

    const initials = useMemo(() => getInitials(userName), [userName]);

    useEffect(() => {
        const localState = JSON.parse(localStorage.getItem('reduxState'));
        if (localState) {
            setUserName(localState?.auth?.username || "");
        }
        setClientName(localStorage.getItem("client_name") || "");
    }, [sidebarState, open]);

    // Access-denied toast must auto-dismiss (and is portaled outside the Drawer
    // so position:fixed isn't trapped by the sidebar transform).
    useEffect(() => {
        if (!showReadonly) return undefined;
        const timeoutId = setTimeout(() => {
            dispatch({
                type: "TRIGGER_READONLY_POPUP",
                payload: false,
            });
        }, READONLY_BOX_HIDE_MS);
        return () => clearTimeout(timeoutId);
    }, [showReadonly, dispatch]);

    useEffect(() => {
        if (!show_user_menu) {
            setMenuPosition(null);
            return undefined;
        }

        const updateMenuPosition = () => {
            const trigger = triggerRef.current;
            if (!trigger) return;
            const rect = trigger.getBoundingClientRect();
            if (open) {
                setMenuPosition({
                    bottom: window.innerHeight - rect.top + 8,
                    left: Math.max(8, rect.left),
                });
            } else {
                setMenuPosition({
                    bottom: Math.max(8, window.innerHeight - rect.bottom),
                    left: rect.right + 8,
                });
            }
        };

        updateMenuPosition();

        const handleOutsideClick = (event) => {
            if (
                triggerRef.current?.contains(event.target) ||
                menuRef.current?.contains(event.target)
            ) {
                return;
            }
            setShowMenu(false);
        };

        window.addEventListener('resize', updateMenuPosition);
        window.addEventListener('scroll', updateMenuPosition, true);
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            window.removeEventListener('resize', updateMenuPosition);
            window.removeEventListener('scroll', updateMenuPosition, true);
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [show_user_menu, open]);

    // Close the menu when the drawer collapses/expands so it doesn't linger mid-transition.
    useEffect(() => {
        setShowMenu(false);
    }, [open]);

    const dismissReadonlyBox = () => {
        dispatch({
            type: "TRIGGER_READONLY_POPUP",
            payload: false,
        });
    };

    const showUserMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu((prev) => !prev);
    };

    const hideUserMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(false);
    };

    const doBtns = (token) => {
        let type = localStorage.getItem("type");
        var btns = [];
        let ids = JSON.parse(localStorage.getItem("ids"));

        ids.data['client_id'].forEach((x) => {
            btns.push({
                label: x.client_name,
                style: '{"color":"#000"}',
                className: 'ssoClBtn hhkj',
                onClick: async () => {
                    document.body.classList.add('fadeswitch');
                    setTimeout(async () => {
                        let error = await SharedUtils.doSsoLogin(x, token, type);
                        if (error != undefined && error != "") {
                            localStorage.removeItem("reduxState");
                            window.location = '/login';
                        }
                    }, 200);
                }
            });
        });

        confirmAlert({
            title: 'Switch Account',
            message: 'Please choose a Customer ID to sign in',
            buttons: btns,
            overlayClassName: 'ssoclselect opacity7',
            closeOnClickOutside: true,
        });
    };

    const switch_account = () => {
        let token = "";
        let type = localStorage.getItem("type");

        if (type == "azure") {
            let msalConfig = {
                auth: {
                    clientId: window.config.azure_clientId,
                    authority: "https://login.microsoftonline.com/common",
                    redirectUri: "/",
                },
                cache: {
                    cacheLocation: "sessionStorage",
                    storeAuthStateInCookie: false,
                }
            };

            let pca = new PublicClientApplication(msalConfig);

            let loginRequest = {
                scopes: ["User.Read"],
                account: pca.getAllAccounts().find(account => account['homeAccountId'] == localStorage.getItem("account_id")),
            };

            pca.acquireTokenSilent(loginRequest).then((response) => {
                token = response.accessToken;
                doBtns(token);
            }).catch(() => {
                localStorage.removeItem("reduxState");
                localStorage.removeItem(METADATA_KEY);
                window.location = '/login';
            });
        } else if (type == "google") {
            window.google.accounts.id.initialize({
                client_id: window.config.googlesso_clientId,
                callback: scc,
                auto_select: true,
            });

            window.google.accounts.id.prompt((notification) => {
                if (notification.isNotDisplayed()) {
                    document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                    window.google.accounts.id.prompt();
                }
            });
        }
    };

    const scc = (res) => {
        doBtns(res.credential);
    };

    const logout = async () => {
        try {
            setIsLoading(true);
            await SharedUtils.apiPost('logout');
            const drawerState = localStorage.getItem('drawerState');
            localStorage.clear();
            localStorage.setItem('drawerState', drawerState);
            window.google.accounts.id.disableAutoSelect();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
            localStorage.removeItem("reduxState");
            localStorage.removeItem(METADATA_KEY);
        }
        window.location = '/login';
    };

    const canSwitchAccount =
        localStorage.getItem("ids") &&
        JSON.parse(localStorage.getItem("ids")).data['client_id'].length > 1;

    return (
        <>
            <div className="nonetworkbar" style={{ display: notwork_down ? "block" : "none" }}>
                Panel network error. Please contact support if the issue presists.
            </div>

            <Box
                id="header"
                onClick={hideUserMenu}
                data-testid="sidebar-user-footer"
                sx={{
                    flexShrink: 0,
                    borderTop: '1px solid #2a3548',
                    px: open ? 2 : 1,
                    py: 1.75,
                    mt: 'auto',
                    position: 'relative',
                    backgroundColor: '#131B23',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: open ? 12 : '50%',
                        transform: open ? 'none' : 'translateX(50%)',
                        zIndex: 2,
                    }}
                >
                    <Spinner
                        as='span'
                        variant='light'
                        size='sm'
                        role='status'
                        className='load_done'
                        aria-hidden='true'
                        animation='border'
                        data-testid={`logout-loading-spinner`}
                        style={{ display: isLoading ? 'block' : 'none' }}
                    />
                </Box>

                <div className="dotmenucontainer" style={{ width: '100%' }}>
                    <Stack
                        ref={triggerRef}
                        direction="row"
                        alignItems="center"
                        justifyContent={open ? 'flex-start' : 'center'}
                        gap={1.5}
                        onClick={showUserMenu}
                        data-testid="usermenu"
                        sx={{
                            cursor: 'pointer',
                            minWidth: 0,
                            width: '100%',
                            borderRadius: '8px',
                            px: open ? 0.5 : 0,
                            py: 0.25,
                            '&:hover': {
                                backgroundColor: open ? 'rgba(255,255,255,0.04)' : 'transparent',
                            },
                        }}
                    >
                        <Box
                            data-testid="user"
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'linear-gradient(180deg, #FF6B4A 0%, #E63D32 100%)',
                                color: '#FFFFFF',
                                fontFamily: 'Montserrat, Inter, sans-serif',
                                fontWeight: 700,
                                fontSize: 13,
                                letterSpacing: '0.02em',
                                userSelect: 'none',
                            }}
                        >
                            {initials}
                        </Box>

                        <Stack
                            minWidth={0}
                            flex={1}
                            sx={{
                                opacity: open ? 1 : 0,
                                width: open ? 'auto' : 0,
                                overflow: 'hidden',
                                pointerEvents: open ? 'auto' : 'none',
                                transition: 'opacity 0.2s ease',
                            }}
                        >
                            <Typography
                                className="client_name"
                                data-testid="sidebar-client-name"
                                sx={{
                                    color: '#FFFFFF !important',
                                    fontSize: '13px !important',
                                    fontWeight: '600 !important',
                                    fontFamily: 'Montserrat, Inter, sans-serif',
                                    lineHeight: 1.3,
                                    marginTop: '0 !important',
                                    height: 'auto !important',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {clientName}
                            </Typography>
                            <Typography
                                data-testid="sidebar-user-email"
                                sx={{
                                    color: '#c3c7dc',
                                    fontSize: 12,
                                    fontWeight: 400,
                                    fontFamily: 'Montserrat, Inter, sans-serif',
                                    lineHeight: 1.3,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {userName}
                            </Typography>
                        </Stack>
                    </Stack>
                </div>
            </Box>

            {show_user_menu &&
                menuPosition &&
                createPortal(
                    <div
                        ref={menuRef}
                        className="dotmenu sidebar-user-menu"
                        data-testid="sidebar-user-menu"
                        style={{
                            display: 'block',
                            position: 'fixed',
                            top: 'auto',
                            right: 'auto',
                            bottom: menuPosition.bottom,
                            left: menuPosition.left,
                            transform: 'none',
                            zIndex: 1400,
                        }}
                    >
                        <div
                            data-testid={"switch account"}
                            className="dodmenuitem"
                            onClick={switch_account}
                            style={{ display: canSwitchAccount ? "block" : "none" }}
                        >
                            Switch Account
                        </div>
                        <div
                            data-testid={"logout"}
                            className="dodmenuitem"
                            style={{ borderTop: canSwitchAccount ? '1.5px solid rgba(230, 230, 230, 0.25)' : 'none' }}
                            onClick={logout}
                        >
                            Logout
                        </div>
                    </div>,
                    document.body
                )}

            {createPortal(
                <div
                    className={showReadonly === true ? "readonlyBox" : "readonlyBox readonlyBoxOff"}
                    data-testid="access-denied-toast"
                    onClick={dismissReadonlyBox}
                >
                    <div className="fleft">
                        <b style={{ color: "red", fontSize: "14px" }}>Access denied</b>
                        <br />You need permission to perform this action
                    </div>
                    <div className="fright readonlyBoxClose">Close</div>
                </div>,
                document.body
            )}
        </>
    );
};

export default Header;
